import type { ContenidoAyuda } from "@/ui/AyudaVista";
import {
  FICHA_ACTIVIDAD,
  FICHA_CRITICO,
  FICHA_IMEIS,
  FICHA_POSESION,
  FICHA_TE_ESPERAN,
  FICHA_TICKET,
} from "./fichasCaso";

/**
 * Ayuda de «El proveedor contestó». La vista no tenía Ayuda; lo único
 * escondido era el resto de los IMEIs en el `title` del «+N más».
 */
export function ayudaProveedorPendiente(): ContenidoAyuda {
  return {
    manual: "proveedor-pendiente",
    intro: (
      <>
        <p>
          Los casos abiertos donde Jimi o Queclink ya contestaron en su ticket y nosotros todavía
          no les respondemos. Van los más viejos primero: ese es el que urge.
        </p>
        <p>
          Un caso sale de aquí al responderle al proveedor, al cerrarlo o al darlo por atendido con
          «⏳ el proveedor contestó», en el encabezado del caso. Una nota interna no cuenta como
          respuesta.
        </p>
      </>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          { label: "⟳ Actualizar", text: "Vuelve a cargar la lista." },
          {
            label: "Un caso de la lista",
            text: "Tócalo para abrirlo. Dentro del caso, «‹ Anterior · Siguiente ›» recorre ESTA lista (con tus filtros), para despacharlos uno tras otro sin volver aquí. Con Ctrl (o ⌘) + clic en el folio se abre en otra pestaña.",
          },
          {
            label: "+N más",
            text: "El caso trae más de tres equipos: tócalo para ver todos sus IMEIs ahí mismo, y «ver menos» para plegarlos.",
          },
          { label: "Limpiar filtros", text: "Quita la búsqueda y los tres filtros." },
        ],
      },
      {
        titulo: "Filtros",
        items: [
          {
            label: "Buscador",
            text: "Busca igual que en Casos: cliente, contactos, folio, TE, ticket de Jimi, IMEI, marca, modelo y descripción, sin importar acentos.",
          },
          {
            label: "Proveedor / estado / responsable",
            text: "Solo ofrecen lo que hay en la lista. «Sin ticket de proveedor» y «— sin asignar —» salen solo si hay casos así.",
          },
        ],
      },
      {
        titulo: "Qué significa cada columna",
        items: [
          {
            label: (
              <span className="flex flex-wrap gap-1">
                <span className="rounded-full border border-ink-600 bg-ink-800 px-2 py-0.5 text-[11px] text-zinc-300">1 d</span>
                <span className="rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[11px] text-amber-300">3 d</span>
                <span className="rounded-full border border-red-500/40 bg-red-500/10 px-2 py-0.5 text-[11px] text-red-300">6 d</span>
              </span>
            ),
            text: "Espera: días desde que escribió el proveedor (no desde que llegó a ArkTickets). Ámbar desde 2 días, rojo desde 5.",
          },
          {
            label: "Proveedor",
            text: "De quién es el ticket (🎫 Jimi o 🎫 Queclink), su estado allá cuando lo sabemos y el número de ticket.",
          },
          { label: "Contestó", text: "Fecha y hora en que respondió el proveedor." },
          { label: "N esperando nuestra respuesta", text: "Cuántos hay con tus filtros y cuántos días lleva el más viejo (en rojo desde 5)." },
        ],
      },
      {
        titulo: "Qué significa cada ficha",
        items: [
          {
            label: "Ficha de estado",
            text: "El estado del caso (Abierto, En revisión, Listo para enviar, Enviado al proveedor, Esperando proveedor, Pendiente cliente).",
          },
          {
            ...FICHA_TICKET,
            text: "Con qué proveedor es el ticket y, junto, su estado allá (se actualiza en cada revisión).",
          },
          FICHA_TE_ESPERAN,
          FICHA_POSESION,
          FICHA_CRITICO,
          FICHA_ACTIVIDAD,
          FICHA_IMEIS,
        ],
      },
    ],
  };
}
